import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import Radio from 'Component/common/radio';
import ChartSeason from 'Component/chart/season'
import SubHead from 'Component/title/sub_head';
import renderingGuide from 'Component/title/guide_content';

import { PERIODS_3 } from 'Constants';
import { setTyp } from 'Reducers/stock'
import { getToday } from 'Util'; 

const Season = () => {

  const { season, typ } = useSelector((state) => state.stock);
  const [data, setData] = useState();
  
  const dispatch = useDispatch();

  useEffect(() => {
    if (season && season.history && season.history.length > 0) {
      const x = [];
      const y = [];
      const z = [];

      const today = getToday('MMDD');

      season.history.forEach((element, index) => {
        x.push(element.TRD_DT);
        y.push(element.SEASONAL);
        if (today === element.TRD_DT) {
          z.push({
            label: {
              show: true,
              position: 'right',
              formatter: '현재',
              fontSize: 10,
              fontWeight: 'bold'
            },
            symbol: 'circle',
            symbolSize: [14, 14],
            itemStyle: {
              color: '#ff0000'
            },
            coord: [index, element.SEASONAL]
          })
        }
      });

      setData({
        x: x,
        y: y,
        z: z
      })
    } else {
      setData(null);
    }
  }, [season])

  function changeTyp(item) {
    dispatch(setTyp(item));
  }

  function checked(item) {
    return typ && item.value === typ.value;
  }

	return (
    <>
      { season && 
        <div className="content7">
          <SubHead guideType="stock" guide="season">
            <img src="/static/images/icon_moon2.png" alt="" />
            <span>토브스탁 SEASONALITY</span>
          </SubHead>
          <div className="cont chartarea">
          <Radio radios={PERIODS_3} selected={typ} onChange={changeTyp} checked={checked} />
            { data 
              ?
              <ChartSeason data={data} title={['']} />
              :
              <div className="chart chart1 chart_none">
                <div className="none_ico"><img src="/static/images/icon_ai.svg" alt="" /></div>
                <div className="none_txt txt_gray">AI 데이터 학습 중입니다.</div>
              </div>
            }
            { season.summary
              ?
              <div className="text">
                <dl>
                  <dt><img src="/static/images/icon_moon2.png" alt="" /></dt>
                  <dd><strong className="txt_blue">{season.summary.WORST_MONTH}월</strong>에 사서 <strong className="txt_red">{season.summary.BEST_MONTH}월</strong>에 팔면 최고 전략입니다!</dd>
                </dl>
              </div>
              :
              <div className="text">
                <dl>
                  <dt><img src="/static/images/icon_moon2.png" alt="" /></dt>
                  <dd className="txt_gray"><strong className="txt_gray">학습</strong> 하고 있습니다.</dd>
                </dl>
              </div>
            }

            {/* 설명 박스: 차트 아래에 깔끔한 흰색 카드 형태의 설명을 추가 (같은 박스 내부) */}
            <div style={{marginTop:14}}>
              <div style={{background:'#fff', borderRadius:8, padding:0, color:'#222'}}>
                  <div style={{fontSize:16, fontWeight:700, marginBottom:0, color:'#333'}}>SEASONALITY</div>
                  <div style={{lineHeight:1.8, color:'#666'}}>
                    <div style={{fontSize:14, fontWeight:600}}>※ 토브스탁 AI 알고리즘으로 분석한 기업의 연간 계절성 추세 지표로, 과거 분석 시점부터 현재까지의 흐름을 보여줍니다.</div>
                    <div style={{fontSize:14, fontWeight:600}}>※ 계절성이 뚜렷한 기업을 매매할 때 매우 유용하며, 연간 매매 횟수가 1회~4회 내외로 적은 장기 투자자분들께 참고 지표로 추천합니다.</div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      }
    </>
  );
}

export default Season;
